import type { SettingsIntakePrintView } from "@buildpy/core/views/g2c/settings-intake-print";
import Notice from "@buildpy/ui/notice";
import { tabHref } from "@/modules/org/ui/settings-tabs";
import A4Fit from "@/modules/print/a4-fit";
import IntakePoster from "@/modules/print/intake-poster";
import PrintPreviewShell from "@/modules/print/print-preview-shell";

// 간편접수 안내문 인쇄 — 설정 간편접수 탭과 같은 권한(그 조직 멤버) · slug 가 없으면 인쇄 없이 안내만.
const Page = ({ data }: { data: SettingsIntakePrintView }) => {
  const { poster } = data;
  const closeHref = tabHref("intake");
  if (!poster) {
    return (
      <PrintPreviewShell closeHref={closeHref} printable={false} title="간편접수 안내문">
        <div data-testid="intake-poster-missing">
          <Notice body="회사 주소 이름이 없어 접수 링크를 만들 수 없습니다." title="접수 링크가 없습니다" />
        </div>
      </PrintPreviewShell>
    );
  }

  return (
    <PrintPreviewShell closeHref={closeHref} subtitle={poster.companyName} title="간편접수 안내문">
      <A4Fit>
        <IntakePoster companyName={poster.companyName} companyTel={poster.companyTel} qrSvg={poster.qrSvg} url={poster.url} />
      </A4Fit>
    </PrintPreviewShell>
  );
};

export default Page;
